import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reverseArr'
})
export class ReversePipe implements PipeTransform {

  transform(value) {
    if (!value || value.length == 0) return;

    return value.reverse();
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/reverse-arr.pipe.ts